// Copyright 2019 Sorama B.V.

import { IWorkflowModalConfig } from "catalogs/WorkflowModalCatalog";
import { IWorkflowModuleConfig } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { IWorkflowModuleInstance } from "../Interfaces/IWorkflowModule";
import { IWorkflowModuleController, IWorkflowRouter } from "../Interfaces/IWorkflowRouter";

export class WorkflowModuleController implements IWorkflowModuleController {
    public isActive = false;
    public moduleInstance: IWorkflowModuleInstance;

    constructor(
        private readonly workflowRouter: IWorkflowRouter,
        public readonly config: IWorkflowModuleConfig,
        public readonly moduleId: number,
        public readonly variant: string
    ) {}

    public get modalConfig(): IWorkflowModalConfig {
        if (this.moduleInstance) {
            return this.moduleInstance.getModalConfig();
        }

        return undefined;
    }

    public makeActive(): void {
        // Reset current
        for (const mod of this.workflowRouter.getModules()) mod.isActive = false;

        this.isActive = true;
        this.workflowRouter.scrollIntoView(this.moduleId);
    }

    public close(): Promise<void> {
        if (this.workflowRouter) {
            this.workflowRouter.closeModule(this.moduleId);
        }

        if (this.moduleInstance) {
            return this.moduleInstance.closeModule();
        }

        return Promise.resolve();
    }
}
